import styled from 'styled-components'

import { useAppDispatch, useAppSelector } from 'src/logic/redux/hooks'
import { setCryptoMethod } from 'src/logic/redux/slices/nftsSlice'
import CustomDropdown from '../customDropdown'
import DDSVG from 'public/assets/gallery/dropDown.svg'

const Dropdown = () => {
  const { cryptoMethod } = useAppSelector((state) => state.nftReducer)
  const dispatch = useAppDispatch()

  const handleCryptoMethodChange = (e: any) => {
    dispatch(setCryptoMethod(e))
  }

  return (
    <SideFilterWrap>
      <CustomDropdown
        value={cryptoMethod}
        handleChange={handleCryptoMethodChange}
        options={['MATIC', 'WETH', 'USDT', 'USDC']}
      />
    </SideFilterWrap>
  )
}

export default Dropdown

export const SideFilterWrap = styled.div`
  gap: 8px;
  max-width: 192px;
  z-index: 5;

  background: url(${DDSVG?.src}) no-repeat right;
  background-size: contain;

  min-height: 50px;
  min-width: 110px;

  display: flex;
  justify-content: center;
  align-items: center;
`
